import styled, { css } from 'styled-components';

import promoColors from 'apps/promo/theme/promoColors';
import promoMedia from 'apps/promo/theme/promoMedia';

const getHeight = (props) => {
    switch (props.size) {
        case 'xs':
            return '304px';
        case 'sm':
            return '400px';
        case 'lg':
            return '510px';
        default:
            return '480px';
    }
};
const getTabletHeight = (props) => {
    switch (props.size) {
        case 'xs':
            return '242px';
        case 'sm':
            return '664px';
        case 'lg':
            return '628px';
        default:
            return props.variant === 'colored' ? '504px' : '628px';
    }
};
const getDesktopHeight = (props) => {
    switch (props.size) {
        case 'xs':
            return '336px';
        case 'sm':
            return '464px';
        case 'lg':
            return '864px';
        default:
            return '648px';
    }
};

const fullwidthTileRow = (props) =>
    (props.fullwidth && props.variant === 'withImg') || (props.fullwidth && props.variant === 'withImgAlt') || props.variant === 'withoutBorder';

const getBackgroundColor = (props) => {
    const { variant, promoDarkPageNew, bgColor } = props;

    if (variant === 'withoutBorder' || variant === 'withImgAlt') {
        return null;
    }

    if (promoDarkPageNew) {
        return promoColors[bgColor];
    }

    if (variant === 'withImg') {
        return 'white';
    }

    return promoColors[bgColor];
};

const CommonCss = css`
    background: ${(props) => getBackgroundColor(props)};
    padding: ${(props) => (props.variant === 'colored' ? '32px' : null)};
    border-radius: ${(props) => (props.variant === 'withoutBorder' || props.variant === 'withImgAlt' ? null : '24px')};
    box-shadow: ${(props) => (props.variant === 'withoutBorder' || props.variant === 'withImgAlt' ? null : promoColors.shadowLoose)};
    height: ${(props) => (props.variant === 'withoutBorder' || props.variant === 'withImgAlt' || props.responsive ? null : '100%')};
    min-height: ${(props) => getHeight(props)};
    box-sizing: border-box;
    word-break: break-word;
    display: flex;
    flex-direction: column;
    align-items: ${(props) => (props.variant === 'withoutBorder' || props.alignCenter ? 'center' : null)};
    justify-content: ${(props) => (props.alignCenter ? 'center' : 'space-between')};
    overflow: hidden;
    position: relative;
    text-align: ${(props) => (props.isCommonButton || props.alignCenter ? 'center' : null)};
    border: ${(props) => (props.promoDarkPageNew ? `1px solid ${promoColors.aubergine}` : null)};

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.variant === 'colored' ? '48px' : null)};
        min-height: ${(props) => (props.variant === 'withoutBorder' || props.responsive ? null : getTabletHeight(props))};
        border-radius: ${(props) => (props.variant === 'withoutBorder' || props.variant === 'withImgAlt' ? null : '36px')};
    }

    ${promoMedia.desktop1440} {
        padding: ${(props) => (props.variant === 'colored' ? '64px' : null)};
        flex-direction: ${(props) => (fullwidthTileRow(props) ? 'row' : null)};
        min-height: ${(props) => (props.variant === 'withoutBorder' ? null : props.fullwidth && props.size !== 'xs' ? '468px' : getDesktopHeight(props))};
        border-radius: ${(props) => (props.variant === 'withoutBorder' || props.variant === 'withImgAlt' ? null : '40px')};
        justify-content: ${(props) => (props.variant === 'withoutBorder' || props.variant === 'withImgAlt' ? 'flex-start' : null)};
    }
`;

export const TileLink = styled.a`
    ${CommonCss};
    text-decoration: none;

    &:focus-visible {
        outline: 1px dashed ${promoColors.purple80};
    }
`;
export const TileBlock = styled.div`
    ${CommonCss};
`;

export const ContentContainerColored = styled.span`
    ${promoMedia.desktop1440} {
        display: block;
        max-width: ${(props) => (props.isCommonButton ? null : '780px')};
    }
`;
export const TileColoredTitle = styled.div`
    margin-bottom: 12px;

    ${promoMedia.tablet744} {
        margin-bottom: 16px;
    }
`;
export const TileColoredButton = styled.span`
    display: inline-flex;
    margin-top: ${(props) => (props.isCommonButton ? '40px' : '16px')};
    justify-content: ${(props) => (props.isCommonButton ? 'center' : 'flex-end')};

    ${promoMedia.desktop1440} {
        margin-top: ${(props) => (props.isCommonButton ? '64px' : '16px')};
    }
`;

export const TileWithImgTitle = styled.div`
    margin-bottom: ${(props) => (props.withImgAlt ? '16px' : '8px')};

    ${promoMedia.tablet744} {
        margin-bottom: ${(props) => (props.withImgAlt ? '16px' : '12px')};
    }

    ${promoMedia.desktop1440} {
        margin-bottom: 16px;
    }
`;

export const TileWithoutBorderTitle = styled.div`
    margin-bottom: 16px;
`;

export const ContentContainer = styled.span`
    display: flex;
    flex-direction: column;
    padding: ${(props) => (props.withImgAlt ? '32px 0' : '32px')};

    ${promoMedia.tablet744} {
        padding: ${(props) => (props.withImgAlt ? '48px 0' : '48px')};
    }
    ${promoMedia.desktop1440} {
        padding: ${(props) => (props.withImgAlt && props.imgTop ? '64px 0 64px 64px' : props.withImgAlt ? '64px 64px 64px 0' : '64px')};
        justify-content: center;
        flex: 1;
    }

    ul {
        list-style: disc outside;
        margin-left: 20px;
    }

    ol {
        list-style: decimal outside;
        margin-left: 26px;

        ${promoMedia.desktop1440} {
            margin-left: 32px;
        }

        li {
            margin-bottom: 8px;

            ${promoMedia.desktop1440} {
                margin-bottom: 16px;
            }

            &:last-child {
                margin-bottom: 0;
            }
        }
    }

    p {
        margin-bottom: 16px;

        &:last-child {
            margin-bottom: 0;
        }
    }
`;

export const TileWithoutBorderContentContainer = styled.span`
    display: flex;
    flex-direction: column;
    justify-content: center;
    padding: 32px;

    ${promoMedia.tablet744} {
        padding: 48px;
    }

    ${promoMedia.desktop1440} {
        padding: 64px;
    }
`;

export const ButtonContainer = styled.span`
    display: block;
    margin-top: 16px;

    ${promoMedia.tablet744} {
        margin-top: 24px;
    }
    ${promoMedia.desktop1440} {
        margin-top: 32px;
    }
`;
export const TileWithoutBorderButtonContainer = styled.span`
    display: block;
    margin-top: 32px;
`;
export const ImgContainer = styled.span`
    display: block;
    overflow: hidden;
    width: ${(props) => (props.responsive ? '335px' : null)};
    min-width: ${(props) => (props.responsive ? '335px' : null)};
    height: ${(props) => (props.responsive ? '335px' : null)};
    margin: ${(props) => (props.responsive ? '0 auto' : null)};
    order: ${(props) => (props.imgBottom ? '2' : null)};

    ${promoMedia.tablet744} {
        width: ${(props) => (props.responsive ? '504px' : null)};
        min-width: ${(props) => (props.responsive ? '504px' : null)};
        height: ${(props) => (props.responsive ? '504px' : null)};
    }

    ${promoMedia.desktop1440} {
        width: ${(props) => (props.withImgAlt ? '400px' : props.fullwidth ? '468px' : null)};
        min-width: ${(props) => (props.withImgAlt ? '400px' : props.fullwidth ? '468px' : null)};
        height: ${(props) => (props.withImgAlt ? '400px' : props.fullwidth ? '468px' : null)};
        margin: 0;
        order: ${(props) => (!props.imgTop ? '2' : null)};
        padding-top: ${(props) => (props.withImgAlt ? '64px' : null)};
    }

    img {
        width: 100%;
    }
`;

export const TileWithoutBorderImgContainer = styled.span`
    display: flex;
    overflow: hidden;
    margin-top: 16px;

    ${promoMedia.tablet744} {
        width: 468px;
        min-width: 468px;
        height: 468px;
        margin-top: 0;
    }

    ${promoMedia.desktop1440} {
        order: ${(props) => (props.imgTop ? '2' : null)};
    }

    img {
        width: 100%;
    }
`;
